import React from 'react';
import { connect } from 'react-redux';
import { useDrag } from 'react-dnd';

function Question({ question }) {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'question', question },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div className="card mb-2">
    <div
      ref={drag}
      style={{
        cursor: 'move',
        opacity: isDragging ? 0.1 : 1
      }}
      className="card-body p-2 bg-white">
      {question.text}
    </div>
  </div>
}

function DocumentQuestions({ questions }) {
  return <>
    {questions.map((question, i) => {
      return <Question key={i} question={question} />
    })}
  </>
}

const mapStateToProps = (state) => {
  return {
    questions: state.questionnaire.current.item
  }
}

export default connect(mapStateToProps)(DocumentQuestions);